module.exports = __webpack_public_path__ + "assets/img/header-bg.9f58b931.jpg";